import { Input, TextField, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Col, FormLabel, Modal, Button, Row } from "react-bootstrap";
import { connect } from "react-redux";
import akmApi from "../../../../../apis/akmApi";
import { URL_AKM } from "../../../../../config";

const ModalDublicatProfil = (props) => {
  const [isOpen, setisOpen] = useState(null);
  const [namaProfilBaru, setnamaProfilBaru] = useState(null);

  useEffect(() => {
    console.log("props", props);
    setisOpen(props.isOpenDublicat);
  }, []);

  const handleOpenModal = () => {
    setisOpen(!isOpen);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    const data = {
      idProfilCbt: props.profil.idProfilCbt,
      namaProfil: namaProfilBaru,
    };

    await akmApi
      .post(URL_AKM.PROFIL_DUBLICATE, data)
      .then((res) => {
        console.log("res", res);
        props.handleRefresh();
        handleOpenModal();
      })
      .catch((err) => {
        console.info("ERR dublicate Profil", err);
      });
  };

  return (
    <>
      <Modal show={isOpen} aria-labelledby="example-custom-modal-styling-title" backdrop="static" keyboard={false} onHide={handleOpenModal}>
        <Modal.Header closeButton>
          <Modal.Title>Dublikat Profil</Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSave}>
          <Modal.Body>
            <Row>
              <Col>
                <Typography color="primary">{props.profil.namaProfil.split("~")[0]}</Typography>
              </Col>
            </Row>
            <Row>
              <Col>
                <TextField label="Nama Profil Baru" id="namaProfilBaru" variant="outlined" size="small" onChange={(e) => setnamaProfilBaru(e.target.value)} required />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="outlined">
              Save
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
      <button className="btn btn-outline-warning btn-sm" title="Dublicat Profil" onClick={() => handleOpenModal()}>
        <i className="fa fa-copy" aria-hidden="true"></i>
      </button>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};

export default connect(mapStateToProps)(ModalDublicatProfil);
